import type {UserEventSpec, UserEventStruct} from '@cohort/shared/schema/apps/userEvent';
import {z} from 'zod';

export const CohortCohortJoinedPropertiesSchema = z.object({
  cohortId: z.string().uuid(),
});
export type CohortCohortJoinedProperties = z.infer<typeof CohortCohortJoinedPropertiesSchema>;

export type CohortCohortJoinedEventStruct = UserEventStruct<
  'cohort.cohort.joined',
  CohortCohortJoinedProperties
>;

export const CohortCohortJoinedEventSpec: UserEventSpec<CohortCohortJoinedEventStruct> = {
  id: 'cohort.cohort.joined',
  propertiesSchema: CohortCohortJoinedPropertiesSchema,
};
